import { render, staticRenderFns } from "./DashboardAgent.vue?vue&type=template&id=72dfa0fa&scoped=true&"
import script from "./DashboardAgent.vue?vue&type=script&lang=js&"
export * from "./DashboardAgent.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAgent.vue?vue&type=style&index=0&id=72dfa0fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dfa0fa",
  null
  
)

export default component.exports